import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import presentationVideo from '../assets/Pinky cloud presentation.mp4';
import './VideoSection.css';

gsap.registerPlugin(ScrollTrigger);

const VideoSection = () => {
  const sectionRef = useRef(null);
  const videoRef = useRef(null);
  const textRef = useRef(null);
  const titleRef = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;
    const video = videoRef.current;
    const text = textRef.current;
    const title = titleRef.current;

    // Animation d'entrée sophistiquée
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top 90%",
        end: "bottom 10%",
        toggleActions: "play none none reverse"
      }
    });

    // Animation parallax de la vidéo
    gsap.to(video, {
      scrollTrigger: {
        trigger: section,
        start: "top bottom",
        end: "bottom top",
        scrub: 1
      },
      y: -100,
      scale: 1.1,
      ease: "none"
    });

    // Animation du titre avec effet grandiose
    tl.fromTo(title, 
      { 
        opacity: 0, 
        scale: 0.8,
        y: 100,
        rotationX: 15
      },
      { 
        opacity: 1, 
        scale: 1,
        y: 0,
        rotationX: 0,
        duration: 1.5,
        ease: "power3.out"
      }
    );

    // Animation du contenu texte avec stagger
    const textElements = text.querySelectorAll('p, .video-features-overlay .feature-overlay, .video-controls');
    
    tl.fromTo(textElements,
      {
        opacity: 0,
        y: 30,
        scale: 0.95
      },
      {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 1,
        stagger: 0.2,
        ease: "power2.out"
      },
      "-=1"
    );

    // Animation de breathing pour les features
    gsap.to('.feature-overlay', {
      scale: 1.05,
      duration: 2,
      ease: "sine.inOut",
      repeat: -1,
      yoyo: true,
      stagger: 0.3
    });

    // Animation du bouton play/pause
    gsap.to('.play-pause-btn', {
      rotation: 360,
      duration: 20,
      ease: "none",
      repeat: -1
    });

    // Animation d'apparition progressive du gradient
    tl.fromTo('.video-overlay-gradient',
      {
        opacity: 0
      },
      {
        opacity: 1,
        duration: 2,
        ease: "power2.inOut"
      },
      "-=1.5"
    );



    // Titre reste fixe - pas d'animation de floating

    return () => {
      tl.kill();
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  return (
    <section className="video-section-fullscreen" ref={sectionRef}>
      <div className="video-container-fullscreen" ref={videoRef}>
        <video
          className="presentation-video-fullscreen"
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          onError={(e) => {
            console.error('Erreur vidéo:', e);
            // Fallback : masquer la vidéo et afficher un fond coloré
            e.target.style.display = 'none';
            document.querySelector('.video-container-fullscreen').style.background = 
              'linear-gradient(135deg, #ff6b9d 0%, #e91e63 100%)';
          }}
        >
          <source src={presentationVideo} type="video/mp4" />
          <div className="video-fallback">
            <h2>Pinky Cloud en action</h2>
            <p>Vidéo en cours de chargement...</p>
          </div>
        </video>
        
        <div className="video-overlay-gradient"></div>
        

        
        <div className="video-content-overlay">
          <div className="container">
            <div className="video-hero-content" ref={textRef}>
              <h2 className="video-hero-title" ref={titleRef}>
                Découvrez Pinky Cloud
              </h2>
              <p className="video-hero-description">
                Cette vidéo vous plonge au cœur de l'action ! Regardez nos chefs 
                préparer vos commandes en live, découvrez les coulisses de notre cuisine 
                et ressentez l'énergie unique qui règne chez Pinky Cloud.
              </p>
              

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;